var Curriculog = Curriculog || {};

Curriculog.EntitiesView = (function ($, _, Backbone, EntitiesView) {

	EntitiesView = Curriculog.CurriculogView.extend({
		tagName: 'ul',
		className: 'hierarchy-list',

		initialize: function (options) {
			this.subviews = [];
			this.users = options.users;
			this.roles = options.roles;
			this.entities = options.entities;
			this.committees = options.committees;
			this.userRoles = options.userRoles;
      this.params = options.params;
			this.listenTo(this.collection, 'add', this.render);
			this.listenTo(this.collection, 'reset', this.render);
			this.listenTo(this.collection, 'remove', this.render);
			this.listenTo(this.collection, 'change', this.render);
			this.listenTo(this.roles, 'new-role', this.render);
			this.listenTo(this.roles, 'remove', this.render);
			this.listenTo(this.userRoles, 'remove', this.render);
			this.listenTo(this.userRoles, 'add', this.render);
			this.listenTo(this.roles, 'change:name', this.render);
			this.listenTo(this.roles, 'change:committee_id', this.render);
			this.listenTo(this.entities, 'change:name', this.render);
		},

		render: function () {
			var openEntities = $('#curriculog-hierarchy-column-content').find('.expand.role-list');
			var openRoles = $('#curriculog-hierarchy-column-content').find('.expand.user-list');
			this.$el.empty();

			if (this.entities.length <= 0) {
	            this.el = nunjucks.render('HierarchyList/emptyHierarchy.html');
	            this.replaceElement(this.el);
				return;
			}

			var rootNodeIDs = this.collection.findRoots();
			var rootEntities = this.getSortedEntities(rootNodeIDs);
			var depth = 0;

			for (var i=0; i < rootEntities.length; i++) {
				var entity = rootEntities[i];
				var relationship = this.collection.findWhere({
					'entity_id': entity.get('id'),
					'entity_parent_id': null,
				});

				var subView = new Curriculog.EntityView({
					model: entity,
					roles: this.roles,
					committees: this.committees,
					users: this.users,
					depth: depth,
					relationship: relationship,
					userRoles: this.userRoles,
          params: this.params
				});

				var last = $(subView.el).appendTo(this.$el);
				this.subviews.push(subView);
				this.renderChildren(entity.get('id'), last, depth+1);
			}
			this.reopenItems(openEntities, openRoles);
		},

		renderChildren: function (id, last, depth) {
			var childIDs = this.collection.findChildren(id);
			var childEntities = this.getSortedEntities(childIDs);
			var newList = $('<ul class="entity-list">').appendTo(last);

			for (var i=0; i < childEntities.length; i++) {
				var entity = childEntities[i];
				var relationship = this.collection.findWhere({
					'entity_id': entity.get('id'),
					'entity_parent_id': id,
				});

				var subView = new Curriculog.EntityView({
					model: entity,
					roles: this.roles,
					committees: this.committees,
					users: this.users,
					depth: depth,
					relationship: relationship,
					userRoles: this.userRoles,
          params: this.params
				});

				var lastElement = $(subView.el).appendTo(newList);
				this.subviews.push(subView);
				this.renderChildren(entity.get('id'), lastElement, depth+1);
			}
		},

		reopenItems: function (openEntities, openRoles) {
			openEntities.each(function (index, item) {
				var relationshipID = $(item).closest('li').attr('id').split('-')[1];

				var entityListElement = $('#relationship-' + relationshipID);
				$(entityListElement).find('.role-list:first').addClass('expand');

				var entityExpandButton = $('#relationship-' + relationshipID + ' > .item-wrapper > .expand-widget');
				$(entityExpandButton).removeClass('expand-widget').addClass('contract-widget');
			});


			openRoles.each(function (index, item) {
				var roleID = $(item).closest('li').attr('id').split('-')[1];

				// We have to select like this because there may be multiple
				// elements with this id if the entity has multiple parents.
				var roleElements = $('[id="role-' + roleID + '"]')

				roleElements.each(function (index, item) {
					$(item).find('.user-list:first').addClass('expand');
					$(item).find('.expand-widget:first').removeClass('expand-widget').addClass('contract-widget');
				});
			});

			hierarchyObject.verticalStretch();
		},

		getSortedEntities: function(entityIDs) {
			var entities = [];
			for (var i=0; i < entityIDs.length; i++) {
				var entity = this.entities.get(entityIDs[i]);

				// sometimes we have hierarchy_entity_parent records that
				// reference deleted hierarchy_entity records.  This check makes
				// sure we do not try to render any deleted entities.
				if (typeof entity !== 'undefined') {
					entities.push(entity);
				}
			}

			// Precache the lowercase version of the name so we dont have
			// to recalculate it for each comparison while sorting.
			for(var i = 0, l = entities.length; i < l; i++){
				entities[i].nameLower = entities[i].get('name').toLowerCase();
			}

			return entities.sort(function (a, b) {
				if (a.nameLower < b.nameLower)
					return -1;
				if (a.nameLower > b.nameLower)
					return 1;
				return 0;
			});
		},
	});

	return EntitiesView;

})($, _, Backbone, Curriculog.EntitiesView || {});
